// extracted by mini-css-extract-plugin
module.exports = {"supInput":"SupInput_supInput__1F9U2","unionNutValve":"SupInput_unionNutValve__2P1Hu"};